import { keyMirror } from 'utils/keyMirror';

export const ActionTypes = keyMirror(
  {
    GET_PROJECT_DATA: null,
  },
  'WelcomeScreen',
);
